import { IApplicationState } from '../../types/redux';

export function getHousesByTurn(state: IApplicationState) {
  return state.newbuilding.housesByTurn;
}
